/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { campaignUpload } from '../../axios/campaignUpload'
import type {
	CampaignUploadError,
	CampaignUploadPathParams,
	CampaignUploadRequest,
	CampaignUploadResponse,
} from '../../types/CampaignUpload'

export const campaignUploadMutationKey = () => [{ url: '/campaigns/:campaign/images' }] as const

export type CampaignUploadMutationKey = ReturnType<typeof campaignUploadMutationKey>

export type CampaignUploadVariables = {
	campaign: CampaignUploadPathParams['campaign']
	data: CampaignUploadRequest
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/CampaignController.php CampaignController::upload */
export function useCampaignUpload<TContext = unknown>(
	options?: UseMutationOptions<
		CampaignUploadResponse,
		AxiosError<CampaignUploadError>,
		CampaignUploadVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: campaignUploadMutationKey(),
		mutationFn: ({ campaign, data }: CampaignUploadVariables) =>
			campaignUpload(campaign, data, config).then(res => res.data),
		...options,
	})
}
